import { useState } from "react";
import { post } from "../networking/RequestService";
import { useSelector } from "react-redux";

const useGetUserExtensionActivities = () => {
    const [userActivities, setUserActivities] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { user } = useSelector((state) => state.auth);

    const fetchUserExtensionActivities = async (customParams = {}) => {
        setLoading(true);
        setError(null);
        try {
            const postParams = {
                fn: "userActivityList",
                ...customParams,
            };
            if (user && user.id) {
                postParams.userId = user.id;
            }
            const res = await post(postParams);
            if (res && res.data && Array.isArray(res.data.myActivities)) {
                setUserActivities(res.data.myActivities);
            } else {
                setUserActivities([]);
            }
        } catch (err) {
            setError(err);
            setUserActivities([]);
        } finally {
            setLoading(false);
        }
    };

    return { userActivities, loading, error, refetch: fetchUserExtensionActivities };
};
export default useGetUserExtensionActivities;
